/**
 * @fileoverview gRPC-Web generated client stub for fleet
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as shared_pb from './shared_pb';

import {
  CreateOwnUserRequest,
  CreateOwnUserResponse,
  GetApprovalStatusResponse,
  GetUserMetadataByIdRequest,
  GetUserMetadataByIdResponse,
  RequestSiteAccessRequest,
  RequestSiteAccessResponse,
  UpdateApprovalStatusRequest,
  UpdateApprovalStatusResponse,
  UpdatePushTokenRequest,
  UpdatePushTokenResponse,
  UpdateUserSummaryRequest,
  UpdateUserSummaryResponse,
  UserExistsResponse,
  UserId,
  UserIdResponse,
  UserProfile,
  UserProfileResponse,
  UserTypeResponse,
  UsersByIdRequest,
  UsersRequest} from './user_pb';

export class UserServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetUserType = new grpcWeb.AbstractClientBase.MethodInfo(
    UserTypeResponse,
    (request: shared_pb.Empty) => {
      return request.serializeBinary();
    },
    UserTypeResponse.deserializeBinary
  );

  getUserType(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null): Promise<UserTypeResponse>;

  getUserType(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UserTypeResponse) => void): grpcWeb.ClientReadableStream<UserTypeResponse>;

  getUserType(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: UserTypeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.UserService/GetUserType',
        request,
        metadata || {},
        this.methodInfoGetUserType,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.UserService/GetUserType',
    request,
    metadata || {},
    this.methodInfoGetUserType);
  }

  methodInfoUserExistsInDatabase = new grpcWeb.AbstractClientBase.MethodInfo(
    UserExistsResponse,
    (request: shared_pb.Empty) => {
      return request.serializeBinary();
    },
    UserExistsResponse.deserializeBinary
  );

  userExistsInDatabase(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null): Promise<UserExistsResponse>;

  userExistsInDatabase(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UserExistsResponse) => void): grpcWeb.ClientReadableStream<UserExistsResponse>;

  userExistsInDatabase(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: UserExistsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.UserService/UserExistsInDatabase',
        request,
        metadata || {},
        this.methodInfoUserExistsInDatabase,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.UserService/UserExistsInDatabase',
    request,
    metadata || {},
    this.methodInfoUserExistsInDatabase);
  }

  methodInfoGetUserId = new grpcWeb.AbstractClientBase.MethodInfo(
    UserIdResponse,
    (request: shared_pb.Empty) => {
      return request.serializeBinary();
    },
    UserIdResponse.deserializeBinary
  );

  getUserId(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null): Promise<UserIdResponse>;

  getUserId(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UserIdResponse) => void): grpcWeb.ClientReadableStream<UserIdResponse>;

  getUserId(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: UserIdResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.UserService/GetUserId',
        request,
        metadata || {},
        this.methodInfoGetUserId,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.UserService/GetUserId',
    request,
    metadata || {},
    this.methodInfoGetUserId);
  }

  methodInfoAddCustomClaims = new grpcWeb.AbstractClientBase.MethodInfo(
    shared_pb.EmptyOrErrorResponse,
    (request: shared_pb.Empty) => {
      return request.serializeBinary();
    },
    shared_pb.EmptyOrErrorResponse.deserializeBinary
  );

  addCustomClaims(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null): Promise<shared_pb.EmptyOrErrorResponse>;

  addCustomClaims(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void): grpcWeb.ClientReadableStream<shared_pb.EmptyOrErrorResponse>;

  addCustomClaims(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.UserService/AddCustomClaims',
        request,
        metadata || {},
        this.methodInfoAddCustomClaims,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.UserService/AddCustomClaims',
    request,
    metadata || {},
    this.methodInfoAddCustomClaims);
  }

  methodInfoGetUserProfile = new grpcWeb.AbstractClientBase.MethodInfo(
    UserProfileResponse,
    (request: shared_pb.Empty) => {
      return request.serializeBinary();
    },
    UserProfileResponse.deserializeBinary
  );

  getUserProfile(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null): Promise<UserProfileResponse>;

  getUserProfile(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UserProfileResponse) => void): grpcWeb.ClientReadableStream<UserProfileResponse>;

  getUserProfile(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: UserProfileResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.UserService/GetUserProfile',
        request,
        metadata || {},
        this.methodInfoGetUserProfile,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.UserService/GetUserProfile',
    request,
    metadata || {},
    this.methodInfoGetUserProfile);
  }

  methodInfoGetApprovalStatus = new grpcWeb.AbstractClientBase.MethodInfo(
    GetApprovalStatusResponse,
    (request: shared_pb.Empty) => {
      return request.serializeBinary();
    },
    GetApprovalStatusResponse.deserializeBinary
  );

  getApprovalStatus(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null): Promise<GetApprovalStatusResponse>;

  getApprovalStatus(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetApprovalStatusResponse) => void): grpcWeb.ClientReadableStream<GetApprovalStatusResponse>;

  getApprovalStatus(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: GetApprovalStatusResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.UserService/GetApprovalStatus',
        request,
        metadata || {},
        this.methodInfoGetApprovalStatus,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.UserService/GetApprovalStatus',
    request,
    metadata || {},
    this.methodInfoGetApprovalStatus);
  }

  methodInfoUpdateApprovalStatus = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateApprovalStatusResponse,
    (request: UpdateApprovalStatusRequest) => {
      return request.serializeBinary();
    },
    UpdateApprovalStatusResponse.deserializeBinary
  );

  updateApprovalStatus(
    request: UpdateApprovalStatusRequest,
    metadata: grpcWeb.Metadata | null): Promise<UpdateApprovalStatusResponse>;

  updateApprovalStatus(
    request: UpdateApprovalStatusRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateApprovalStatusResponse) => void): grpcWeb.ClientReadableStream<UpdateApprovalStatusResponse>;

  updateApprovalStatus(
    request: UpdateApprovalStatusRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: UpdateApprovalStatusResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.UserService/UpdateApprovalStatus',
        request,
        metadata || {},
        this.methodInfoUpdateApprovalStatus,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.UserService/UpdateApprovalStatus',
    request,
    metadata || {},
    this.methodInfoUpdateApprovalStatus);
  }

  methodInfoUpdatePushToken = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdatePushTokenResponse,
    (request: UpdatePushTokenRequest) => {
      return request.serializeBinary();
    },
    UpdatePushTokenResponse.deserializeBinary
  );

  updatePushToken(
    request: UpdatePushTokenRequest,
    metadata: grpcWeb.Metadata | null): Promise<UpdatePushTokenResponse>;

  updatePushToken(
    request: UpdatePushTokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdatePushTokenResponse) => void): grpcWeb.ClientReadableStream<UpdatePushTokenResponse>;

  updatePushToken(
    request: UpdatePushTokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: UpdatePushTokenResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.UserService/UpdatePushToken',
        request,
        metadata || {},
        this.methodInfoUpdatePushToken,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.UserService/UpdatePushToken',
    request,
    metadata || {},
    this.methodInfoUpdatePushToken);
  }

  methodInfoCreateUser = new grpcWeb.AbstractClientBase.MethodInfo(
    shared_pb.EmptyOrErrorResponse,
    (request: UserProfile) => {
      return request.serializeBinary();
    },
    shared_pb.EmptyOrErrorResponse.deserializeBinary
  );

  createUser(
    request: UserProfile,
    metadata: grpcWeb.Metadata | null): Promise<shared_pb.EmptyOrErrorResponse>;

  createUser(
    request: UserProfile,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void): grpcWeb.ClientReadableStream<shared_pb.EmptyOrErrorResponse>;

  createUser(
    request: UserProfile,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.UserService/CreateUser',
        request,
        metadata || {},
        this.methodInfoCreateUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.UserService/CreateUser',
    request,
    metadata || {},
    this.methodInfoCreateUser);
  }

  methodInfoUpdateUserSummary = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateUserSummaryResponse,
    (request: UpdateUserSummaryRequest) => {
      return request.serializeBinary();
    },
    UpdateUserSummaryResponse.deserializeBinary
  );

  updateUserSummary(
    request: UpdateUserSummaryRequest,
    metadata: grpcWeb.Metadata | null): Promise<UpdateUserSummaryResponse>;

  updateUserSummary(
    request: UpdateUserSummaryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateUserSummaryResponse) => void): grpcWeb.ClientReadableStream<UpdateUserSummaryResponse>;

  updateUserSummary(
    request: UpdateUserSummaryRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: UpdateUserSummaryResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.UserService/UpdateUserSummary',
        request,
        metadata || {},
        this.methodInfoUpdateUserSummary,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.UserService/UpdateUserSummary',
    request,
    metadata || {},
    this.methodInfoUpdateUserSummary);
  }

  methodInfoUpdateUserAddress = new grpcWeb.AbstractClientBase.MethodInfo(
    shared_pb.EmptyOrErrorResponse,
    (request: shared_pb.Address) => {
      return request.serializeBinary();
    },
    shared_pb.EmptyOrErrorResponse.deserializeBinary
  );

  updateUserAddress(
    request: shared_pb.Address,
    metadata: grpcWeb.Metadata | null): Promise<shared_pb.EmptyOrErrorResponse>;

  updateUserAddress(
    request: shared_pb.Address,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void): grpcWeb.ClientReadableStream<shared_pb.EmptyOrErrorResponse>;

  updateUserAddress(
    request: shared_pb.Address,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.UserService/UpdateUserAddress',
        request,
        metadata || {},
        this.methodInfoUpdateUserAddress,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.UserService/UpdateUserAddress',
    request,
    metadata || {},
    this.methodInfoUpdateUserAddress);
  }

  methodInfoGetUsersByOperatingArea = new grpcWeb.AbstractClientBase.MethodInfo(
    UserProfileResponse,
    (request: UsersRequest) => {
      return request.serializeBinary();
    },
    UserProfileResponse.deserializeBinary
  );

  getUsersByOperatingArea(
    request: UsersRequest,
    metadata?: grpcWeb.Metadata) {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/fleet.UserService/GetUsersByOperatingArea',
      request,
      metadata || {},
      this.methodInfoGetUsersByOperatingArea);
  }

  methodInfoGetUsersByIds = new grpcWeb.AbstractClientBase.MethodInfo(
    UserProfileResponse,
    (request: UsersByIdRequest) => {
      return request.serializeBinary();
    },
    UserProfileResponse.deserializeBinary
  );

  getUsersByIds(
    request: UsersByIdRequest,
    metadata?: grpcWeb.Metadata) {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/fleet.UserService/GetUsersByIds',
      request,
      metadata || {},
      this.methodInfoGetUsersByIds);
  }

  methodInfoRemoveUser = new grpcWeb.AbstractClientBase.MethodInfo(
    shared_pb.EmptyOrErrorResponse,
    (request: UserId) => {
      return request.serializeBinary();
    },
    shared_pb.EmptyOrErrorResponse.deserializeBinary
  );

  removeUser(
    request: UserId,
    metadata: grpcWeb.Metadata | null): Promise<shared_pb.EmptyOrErrorResponse>;

  removeUser(
    request: UserId,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void): grpcWeb.ClientReadableStream<shared_pb.EmptyOrErrorResponse>;

  removeUser(
    request: UserId,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.UserService/RemoveUser',
        request,
        metadata || {},
        this.methodInfoRemoveUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.UserService/RemoveUser',
    request,
    metadata || {},
    this.methodInfoRemoveUser);
  }

  methodInfoCreateOwnUser = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateOwnUserResponse,
    (request: CreateOwnUserRequest) => {
      return request.serializeBinary();
    },
    CreateOwnUserResponse.deserializeBinary
  );

  createOwnUser(
    request: CreateOwnUserRequest,
    metadata: grpcWeb.Metadata | null): Promise<CreateOwnUserResponse>;

  createOwnUser(
    request: CreateOwnUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: CreateOwnUserResponse) => void): grpcWeb.ClientReadableStream<CreateOwnUserResponse>;

  createOwnUser(
    request: CreateOwnUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: CreateOwnUserResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.UserService/CreateOwnUser',
        request,
        metadata || {},
        this.methodInfoCreateOwnUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.UserService/CreateOwnUser',
    request,
    metadata || {},
    this.methodInfoCreateOwnUser);
  }

  methodInfoRequestSiteAccess = new grpcWeb.AbstractClientBase.MethodInfo(
    RequestSiteAccessResponse,
    (request: RequestSiteAccessRequest) => {
      return request.serializeBinary();
    },
    RequestSiteAccessResponse.deserializeBinary
  );

  requestSiteAccess(
    request: RequestSiteAccessRequest,
    metadata: grpcWeb.Metadata | null): Promise<RequestSiteAccessResponse>;

  requestSiteAccess(
    request: RequestSiteAccessRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: RequestSiteAccessResponse) => void): grpcWeb.ClientReadableStream<RequestSiteAccessResponse>;

  requestSiteAccess(
    request: RequestSiteAccessRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: RequestSiteAccessResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.UserService/RequestSiteAccess',
        request,
        metadata || {},
        this.methodInfoRequestSiteAccess,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.UserService/RequestSiteAccess',
    request,
    metadata || {},
    this.methodInfoRequestSiteAccess);
  }

}

export class UserMetadataClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetUserMetadataById = new grpcWeb.AbstractClientBase.MethodInfo(
    GetUserMetadataByIdResponse,
    (request: GetUserMetadataByIdRequest) => {
      return request.serializeBinary();
    },
    GetUserMetadataByIdResponse.deserializeBinary
  );

  getUserMetadataById(
    request: GetUserMetadataByIdRequest,
    metadata: grpcWeb.Metadata | null): Promise<GetUserMetadataByIdResponse>;

  getUserMetadataById(
    request: GetUserMetadataByIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetUserMetadataByIdResponse) => void): grpcWeb.ClientReadableStream<GetUserMetadataByIdResponse>;

  getUserMetadataById(
    request: GetUserMetadataByIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: GetUserMetadataByIdResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.UserMetadata/GetUserMetadataById',
        request,
        metadata || {},
        this.methodInfoGetUserMetadataById,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.UserMetadata/GetUserMetadataById',
    request,
    metadata || {},
    this.methodInfoGetUserMetadataById);
  }

}

